/* eslint-disable react-hooks/exhaustive-deps */
import './styles/index.css';
import React, { useEffect } from 'react';
// custom
import { useStore } from './Context';
import { isMobile } from 'react-device-detect';
// components
import Loading from './components/Loading';
import CameraComponent from './components/Camera/Camera';
import Modal from './components/Modal';
import SignatureModal from './components/Modal/SignatureModal';
// pages
import StepWelcome from './pages/StepWelcome.jsx';
import StepContract from './pages/StepContract.jsx';
import StepDocuments from './pages/StepDocuments.jsx';
import StepSelfieIntro from './pages/StepSelfieIntro.jsx';
import StepSelfieNeutral from './pages/StepSelfieNeutral.jsx';
import StepSelfieSpecial from './pages/StepSelfieSpecial.jsx';
import StepDigitalSign from './pages/StepDigitalSign.jsx';
import StepEnd from './pages/StepEnd';
// errors
import ErrorBase from './pages/Errors/ErrorBase';
import ErrorNotMobile from './pages/Errors/ErrorNotMobile';
import ErrorOrientation from './pages/Errors/ErrorOrientation';
// services
import signs from './services/signs'
import loanlogs from './services/loanlogs';
// RUM
import AwsCWRum from './config/rum';

AwsCWRum();

function App() {
    const { error, step, loading, camera, modal, setError, setUserData, setLoading } = useStore();

    const selectError = error?.extra?.key || null;
    let content;

    async function handleUserData() {
        try {
            setLoading(true);
            const response = await signs.getUser(setError)
            loanlogs.success('/welcome', { response }).catch(console.log)
            setUserData(response)
        }
        catch (error) {
            setError(error)
        }
        finally {
            setLoading(false)
        }

    };

    useEffect(() => {
        if (step !== 8 && selectError !== 'attempts_are_over') {
            handleUserData();
        }
    }, [step]);

    switch (step) {
        case 1: content = <StepWelcome />; break;
        case 2: content = <StepContract />; break;
        case 3: content = <StepDocuments />; break;
        case 4: content = <StepSelfieIntro />; break;
        case 5: content = <StepSelfieNeutral />; break;
        case 6: content = <StepSelfieSpecial />; break;
        case 7: content = <StepDigitalSign />; break;
        case 8: content = <StepEnd />; break;
        default: content = <StepWelcome />; break;
    }

    if (!isMobile) {
        return <ErrorNotMobile />
    }

    if (selectError) {
        return <ErrorBase errorKey={selectError} />
    }

    if (error.error) {
        return <ErrorBase />
    }

    if (loading) {
        return <Loading />
    }

    if (camera.open) {
        return <CameraComponent />
    }

    return (
        <>
            {content}
            <Modal>
                <SignatureModal id='customModal' modal={modal} />{' '}
            </Modal>
            <ErrorOrientation />
        </>
    );
}

export default App;
